import type { JobItemResult } from '@xing-com/crate-common-graphql-types';

import { checkBookmarkState } from '../utils';

export const createJobsCards = (jobs: Partial<JobItemResult>[]) => {
  return jobs.flatMap((job) => {
    if (job?.jobDetail?.__typename !== 'VisibleJob') return [];

    const { jobDetail } = job;

    const cities =
      jobDetail?.locations?.map((location) => location?.city).filter(Boolean) ||
      [];

    return [
      {
        activeUntil: jobDetail.activeUntil,
        id: jobDetail.id,
        companyName: jobDetail?.companyInfo?.company?.companyName || '',
        companyLogo: jobDetail?.companyInfo?.company?.logos?.logo96px ?? '',
        bookmarked: checkBookmarkState(
          jobDetail?.userInteractions?.bookmark?.state
        ),
        title: jobDetail?.title,
        refreshedAt: jobDetail.refreshedAt,
        location: {
          cities: cities,
          country: jobDetail?.locations?.[0]?.country?.localizationValue || '',
        },
        link: jobDetail?.url,
      },
    ];
  });
};
